import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { BreadcrumbModel } from '@shared/models/breadcrumb.model';
import { Observable, Subject } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { IQueryState } from '@shared/store/reducers/query.reducer';
import { ActivatedRoute, Router } from '@angular/router';
import {skip, take, takeUntil} from 'rxjs/operators';
import { getQueryResponse } from '@shared/store/selectors/query.selector';
import { QueryProvider } from '@shared/queries/query-provider';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';
import {
  CreateMonthlyFilingCommand, CreateQuarterlyFilingCommand, MarkAnnualFilingCommand,
  SyncProjectEntityToCompanyCommand,
  UpdateArrangementCommand
} from '../../commands/dac6-reporter.command';
import {CommandService} from '@core/services/command.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {DialogModel} from '@shared/models/dialog.model';
import {StartDataSurveyFromTemplateCommand} from '@shared/commands/shared.commands';
import {DialogService} from '@shared/services/dialog-service';
import { Guid } from 'guid-typescript';
import {DynamicFieldItem} from '@shared/components/dynamic-form/dynamic-form-item';
import {CollaborationState} from '../../../task-manager/collaboration/store/collaboration.reducer';
import {CreateChatConversationCommand} from '../../../task-manager/collaboration/store/collaboration.command';
import {ContentScope, PlatformCommand} from '@shared/commands/command-base';
import {ConversationComponentName} from '../../../task-manager/collaboration/store/collaboration.constants';
import {CreateChatConversationAction} from '../../../task-manager/collaboration/store/collaboration.action';
import {Configuration} from "@shared/models/configuration";
import {BasketId, Dac6FieldConfigKeys, FieldefinitionDataType, SourceTypes} from "../../Fields";
import {BasketProvider} from "@shared/models/basket-provider";
import {DetailsInstructionService} from "@shared/services/details-instruction-service";
import {SetActivityFeedAction} from "@shared/components/platform-sidebar/store/platform-sidebar.action";
import {PlatformSidebarState} from "@shared/components/platform-sidebar/store/platform-sidebar.reducer";
import { FileStoreCommonService } from '@features/file-manager/services/file-store-common.service';

@Component({
    standalone: false,
    selector: 'particle-arrangement-detail',
  templateUrl: './arrangement-detail.component.html',
  styleUrls: ['./arrangement-detail.component.scss']
})
export class ArrangementDetailComponent implements OnInit, OnDestroy, AfterViewInit {
  breadcrumbs: BreadcrumbModel[];
  breadcrumbKey: string;
  id: any;
  breadcrumbs$: any;
  ngUnsubscribe$ = new Subject<void>();
  item$: Observable<any>;
  sourceType: string;
  showDelete: boolean;
  item: any;
  endpointName: string;
  isProjectSpecific: boolean;
  showOriginal: boolean;
  invalidateSubject: InvalidateSubject;
  showLanguageOption: boolean;
  autoSave: boolean;
  isDirty: boolean;
  toogled: boolean;
  editedFields: string[] = [];
  totalChanges: number = 0;
  autoSaveInterval;
  formField: DynamicFieldItem;
  fieldConfig: any;
  selectedSectionHearderKey : string;
  isAutoTagRefresh: boolean;
  changedValuesFieldDefination = [];
  constructor(
              private router: Router,
              protected activatedRoute: ActivatedRoute,
              private commandService: CommandService,
              private snackBarService: SnackBarService,
              private detailsInstructionService: DetailsInstructionService,
              private dialogService: DialogService,
              private collaborationStore: Store<CollaborationState>,
              private platformSidebarStore: Store<PlatformSidebarState>,
              private queryState: Store<IQueryState>,
              private fileStoreCommonService: FileStoreCommonService
            ) {
    this.breadcrumbs = [
      <BreadcrumbModel>{
        id : 'Arrangement',
        title: 'Arrangement',
        type: 'Arrangement',
        relativeUrl: 'dac6-reporter/arrangement'
      }
    ];
    this.breadcrumbKey = 'BreadcrumbByArrangementId';
    this.sourceType = 'Arrangement';
    this.endpointName = 'Dac6Api';
    this.isProjectSpecific = false;
    this.showOriginal = false;
    this.showLanguageOption = false;
    this.invalidateSubject = new InvalidateSubject();
    this.autoSave = false;
    this.selectedSectionHearderKey = '';
  }
  async canDeactivate() {
    let res = true;
    if(this.editedFields.length > 0){
      const question = 'You have unsaved changes. Do you want to save these changes before continuing?';
      const dialogRef = this.dialogService.showConfirmDialog('Unsaved Changes', 'Yes', 'No', null, question);
      dialogRef.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(data => {
        if (data.action === 'OK') {
          this.save();
          res = false;
        }
        else if(data.action === 'Closed'){
          res = false;
        }
      });
      await dialogRef.toPromise();
    }
    return res;
  }
  ngAfterViewInit() {

  }
  ngOnInit() {
    this.invalidateSubject.getObservale().pipe(takeUntil(this.ngUnsubscribe$)).subscribe((state: any) => {
      if (state.indexOf('SaveChangesOnPageChangeOrTab') >= 0) {
        if(this.editedFields.length > 0)this.save();
      }
    });
    this.isDirty = true;
    this.toogled = true;
    console.log(this.isDirty);
    const command = new SyncProjectEntityToCompanyCommand(false);
    this.commandService.executeCommand(command).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(commandState => {
      console.log(commandState);
    });
    this.activatedRoute.params.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((params: any) => {
      this.id = params.id;
      this.trackArrangementViewActivity(params.id);
      const config = Configuration.getSmartGridConfig(Dac6FieldConfigKeys.ArrangmentAEFieldConfigKey);
      config.Parameters['ID'] = this.id;

      this.breadcrumbs$ = this.queryState.pipe(takeUntil(this.ngUnsubscribe$), select(getQueryResponse, this.breadcrumbKey));
      this.breadcrumbs$.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(state => {
        if (state) {
          this.breadcrumbs = state.breadcrumb;
        }
      });
      QueryProvider.invokeQuery(this.queryState, this.breadcrumbKey, {'[ID]': this.id});
      this.item$ = this.queryState.pipe(takeUntil(this.ngUnsubscribe$), select(getQueryResponse, 'ArrangementRowById'));
      this.item$.pipe(skip(1),takeUntil(this.ngUnsubscribe$)).subscribe((state: any) => {
        if (this.isAutoTagRefresh) {
          this.isAutoTagRefresh = false;
          this.autoTagRefresh(state);
          return;
        }
        const item = state.item;
        if (item && item.cells) {
          if (!this.item) {
            this.item = item;
          }
          // this.platformSidebarStore.dispatch(new SetActivityFeedAction({type: 'ReferenceCode', id: this.item.cells['ReferenceCode'].value, title: this.item.cells['CaseId'].value, isDefault: false, isUserAction: false}));
          this.formField = state.formField;
          this.fieldConfig = state.fieldConfig;
          Object.keys(item.cells).forEach(key => {
            if (!this.item.cells[key]) {
              this.item.cells[key] = {};
            }
            this.item.cells[key].isDirty = false;
            this.item.cells[key].actualValue = item.cells[key].value;
            this.item.cells[key].value = item.cells[key].value;
            this.item.cells[key].displayText = item.cells[key].displayText;
          });

        }
        this.editedFields.splice(0, this.editedFields.length);
      });
      QueryProvider.invokeQuery(this.queryState, 'ArrangementRowById', {'[ID]': this.id});
    });

    this.autoSaveInterval = setInterval( () => {
      if (this.isDirty && this.autoSave) {
        this.save();
      }
    }, 30000);
  }
  trackArrangementViewActivity(id: string){
    const command = new PlatformCommand('TrackArrangementViewCommand','DAC6Api');
    command.fieldValues['Id'] = id;
    command.fieldValues['SourceType'] = SourceTypes.Arrangement;
    this.commandService.executePlatformCommand(command).subscribe((response: any)=>{
      console.log(response);
    })
  }
  ngOnDestroy(): void {
    if (this.autoSaveInterval) {
      clearInterval(this.autoSaveInterval);
    }
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
  startDataSurvey() {
    const title = this.item.cells['Title'].value;
    const caseId = this.item.cells['CaseId'].value;
    const collaborativeTemplateId = 'collaborative-dac6-form';
    const individualTemplateId = 'individual-dac6-form';
    const input = {
      title: `${caseId}-${title}`,
      description: '',
      showResponseOption: true,
      isIndividualResponse: false
    };
    const dialogModel: DialogModel = DialogModel.create(
      'Start Survey',
      'AddSurveyDialogComponent', input,
      '600px',
      '700px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
      console.log(res);
      if (res && res.action === 'OK') {
        const surveyTemplateId = res.data.input.isIndividualResponse ? individualTemplateId : collaborativeTemplateId;
        const command = new StartDataSurveyFromTemplateCommand(this.item.id,
          surveyTemplateId,
          res.data.input.title,
          res.data.input.description,
          caseId
        );
        this.commandService.executeCommand(command).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(state => {
          console.log('StartDataSurveyFromTemplateCommand returned ', state);
          if (state && state.Payload && state.Payload.SurveyId) {
            this.router.navigateByUrl(`data-survey/${state.Payload.SurveyId}`);
          }
        });
      }
    });
  }

  onValueChanged(event) {
    if (event && event.action === 'ApplyTagsSuccess') {
      this.isAutoTagRefresh = true;
      QueryProvider.invokeQuery(this.queryState, 'ArrangementRowById', {'[ID]': this.id});
      this.invalidateSubject.invalidate('Refresh|' + Guid.create().toString());
      return;
    }
    const exist = this.changedValuesFieldDefination.find( o => o.key === event.event.fieldDefinition.key);
    if (!exist) {
      this.changedValuesFieldDefination.push(event.event.fieldDefinition);
    }
    if (event) {
      switch (event.action) {
        case 'ValueChanged':
          this.totalChanges += event.increment;
          this.dirtyChanged('ENABLE');
          if (this.toogled) {this.toogled = false; }
          break;
        case 'Edit':
          this.save();
          break;
      }
    }
  }

  private dirtyChanged(action) {
    switch (action) {
      case 'ENABLE':
        if (!this.toogled) {
          this.isDirty = false;
          this.toogled = true;
        }
        break;
      case 'DISABLE':
        if (!this.toogled) {
          this.isDirty = false;
          this.toogled = true;
        }
        break;
    }
  }

  save(): void {
      if (this.editedFields.length) {
        const item = {};
        item['id'] = this.item.id;
        item['fieldValues'] = {};
        this.editedFields.forEach(fieldKey => {
          if (this.item.cells[fieldKey]) {
            item['fieldValues'][fieldKey] = this.item.cells[fieldKey].value;
            const fieldDef = this.changedValuesFieldDefination.find( o => o.key === fieldKey);
            if (fieldDef && fieldDef.dataType === FieldefinitionDataType.Attachment && this.item.cells['fileName']) {
              item['fieldValues'][`${fieldKey}FileName`] = this.item.cells['fileName'];
            }
          }
        });
        const command = new UpdateArrangementCommand(item);
        const currentBasket = BasketProvider.getCurrentBasket();
        switch (currentBasket.id){
          case BasketId.Mexico:
            command.IsHallmarkAutomatedCopy = true;
            break;
          default:
        }
        this.commandService.executeCommand(command).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(commandState => {
          // this.snackBarService.showInformation('Arrangement Data Saved');
          QueryProvider.invokeQuery(this.queryState, 'ArrangementRowById', {'[ID]': this.id});
          this.totalChanges = 0;
          this.dirtyChanged('DISABLE');
          this.toogled = false;
          this.invalidateSubject.invalidate('SaveChanges|Refresh|' + Guid.create().toString());
        });
      } else { this.invalidateSubject.invalidate('SaveChanges|Refresh|' + Guid.create().toString()); }

  }

  autoSaveChanged(): void {
    if (!this.autoSave) {
      this.save();
    }
  }

  autosave () {
    // fixing build error
  }

  createMonthlyFiling() {
    const command = new CreateMonthlyFilingCommand(this.id, '', '', {});
    this.commandService.executeCommand(command).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(state => {
      if (state) {
        this.router.navigateByUrl('dac6-reporter/filing/monthly');
      }
    });
  }

  createQuarterlyFiling() {
    const command = new CreateQuarterlyFilingCommand(this.id, '', '', {});
    this.commandService.executeCommand(command).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(state => {
      if (state) {
        this.router.navigateByUrl('dac6-reporter/filing/quarterly');
      }
    });
  }

  markAnnualFiling() {
    const command = new MarkAnnualFilingCommand(this.id);
    this.commandService.executeCommand(command).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(state => {
      this.invalidateSubject.invalidate();
    });
  }

  navigateToCaseFolder() {
      let relativePath = 'DAC6 Reporter/[CASE_ID]/Arrangements';
      const caseId = this.item.cells['CaseId'].value;
      relativePath = relativePath.replace('[CASE_ID]', caseId);
      // const relativeUrl$ = this.queryState.pipe(select(getQueryResponse, 'UrlByRelativePath'))
      //   .pipe(take(2));
      // relativeUrl$.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(state => {
      //   console.log('RelativeUrl', state);
      //   if (state) {
      //     this.router.navigateByUrl(state);
      //   }
      // });

      // QueryProvider.invokeQuery(this.queryState, 'UrlByRelativePath', {'[RELATIVE_PATH]': relativePath});
      this.fileStoreCommonService.navigateToClientFolderUsingRelativepath(relativePath);
  }

  openConversation() {
    const sourceInfoDictionary = {
      'sourceInfoDictionary': {
        CaseGuid: this.item.cells['CaseGUID'].value,
        caseId: this.item.cells['CaseId'].displayText
      }
    };
    const createChatConversationCommand = new CreateChatConversationCommand(
      '[COMPANY_ID]-chat',
      `${this.item.cells['CaseId'].displayText}`,
      true,
      0,
      'DAC6',
      [],
      true,
      this.item.cells['CaseGUID'].value,
      sourceInfoDictionary
    );
    createChatConversationCommand.scope = ContentScope.Company;
    this.collaborationStore.dispatch(new CreateChatConversationAction(createChatConversationCommand, ConversationComponentName));
  }
  openHallmarkTagging() {
    const dialogueModel = DialogModel.create('Hallmark Tagging', 'HallmarkTagSuggestionDialogComponent', {'Id':this.id});
    dialogueModel.maxWidth = '600px';
    dialogueModel.minWidth = '600px';
    this.dialogService.showOkCancelDialog(dialogueModel).subscribe(res => {
      if (res.data.action === 'nevigateToHallmark') {
        //this.formField.children[1].children[1].isExpanded = true;
        //this.invalidateSubject.invalidate('Refresh|' + Guid.create().toString());
        //this.router.navigateByUrl(`dac6-reporter/arrangement/c10bc2e0-6512-4f5e-8170-04492b6f597f`,{queryParams: {category: res.data.category, key: res.data.key}} );
      }
    });
  }
  selectedSectionIndexChange($event){
    this.selectedSectionHearderKey = $event;
  }
  hasHallmarkTagging(){
    const currentBasket = Configuration.getCurrentBasket();
    if(currentBasket){
      return currentBasket.basketKey === '' && this.selectedSectionHearderKey.toLowerCase().includes('_hallmarktagging');
    }
    return this.selectedSectionHearderKey.toLowerCase().includes('_hallmarktagging');
  }

  private autoTagRefresh(state: any) {
    if (!this.item.cells['Suggested_Hallmarks']) {
      this.item.cells['Suggested_Hallmarks'] = {};
    }
    if (!this.item.cells['ApplyTags']) {
      this.item.cells['ApplyTags'] = {};
    }
    if (state.item.cells['Suggested_Hallmarks'] && state.item.cells['Suggested_Hallmarks'].value) {
      this.item.cells['Suggested_Hallmarks'].isDirty = false;
      this.item.cells['Suggested_Hallmarks'].actualValue = state.item.cells['Suggested_Hallmarks'].value;
      this.item.cells['Suggested_Hallmarks'].value = state.item.cells['Suggested_Hallmarks'].value;
      this.item.cells['Suggested_Hallmarks'].displayText = state.item.cells['Suggested_Hallmarks'].displayText;
    }
    if (state.item.cells['ApplyTags'] && state.item.cells['ApplyTags'].value) {
      this.item.cells['ApplyTags'].isDirty = false;
      this.item.cells['ApplyTags'].actualValue = state.item.cells['ApplyTags'].value;
      this.item.cells['ApplyTags'].value = state.item.cells['ApplyTags'].value;
      this.item.cells['ApplyTags'].displayText = state.item.cells['ApplyTags'].displayText;
    }
  }
  onFieldSelectionChanged(event){
    if(event.metaData && event.metaData['DirectoryPath']){
      const caseId = this.item.cells['CaseId'].value;
      event.metaData['DirectoryPath'] = event.metaData['DirectoryPath'].replace('[CASE_ID]' ,caseId );
    }
    const currentSourceType = BasketProvider.getBasketMappedSourceType(SourceTypes.Arrangement);
    this.detailsInstructionService.openFieldDefinitionFieldDetial(event, currentSourceType);
  }
}
